import { render, staticRenderFns } from "./DiscountCodeForm.vue?vue&type=template&id=f71ac2e8"
import script from "./DiscountCodeForm.vue?vue&type=script&lang=js"
export * from "./DiscountCodeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports